module.exports = __webpack_public_path__ + "static/media/loading.8e591aa9.gif";